module.exports = __webpack_public_path__ + "img/4-2.77d148d5.svg";